
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MixingItemsGrid extends Serenity.EntityGrid<MixingItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MixingItems'; }
        protected getDialogType() { return MixingItemsDialog; }
        protected getIdProperty() { return MixingItemsRow.idProperty; }
        protected getInsertPermission() { return MixingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MixingItemsRow.localTextPrefix; }
        protected getService() { return MixingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}